import FastMarquee from "react-fast-marquee";

export default function Marquee() {
  const items = [
    "Apex Dental Care",
    "ദന്താശുപത്രി",
    "Kodanchery Arcade · Edamuttam",
    "എടമുട്ടം · കേരള",
    "Painless. Precise. Considered.",
  ];
  return (
    <section
      aria-hidden="true"
      data-testid="marquee-section"
      className="relative py-16 md:py-20 border-y border-bone bg-porcelain overflow-hidden"
    >
      {/* Kolam-inspired ornament */}
      <div className="absolute left-1/2 -translate-x-1/2 -top-3 opacity-40 pointer-events-none">
        <svg width="56" height="24" viewBox="0 0 56 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="28" cy="12" r="2" fill="#8FA6BD" />
          <path d="M4 12 Q 16 2 28 12 Q 40 22 52 12" stroke="#8FA6BD" strokeWidth="0.8" fill="none" />
          <path d="M4 12 Q 16 22 28 12 Q 40 2 52 12" stroke="#8FA6BD" strokeWidth="0.8" fill="none" />
        </svg>
      </div>
      <FastMarquee speed={22} gradient={false} pauseOnHover={false} className="marquee-track">
        {items.concat(items).map((t, i) => (
          <span
            key={i}
            className={`${/[\u0D00-\u0D7F]/.test(t) ? 'font-malayalam' : 'font-serif italic'} text-[11vw] md:text-[9vw] leading-none px-10 outline-text whitespace-nowrap`}
          >
            {t} <span className="mx-6 text-taupe">✦</span>
          </span>
        ))}
      </FastMarquee>
    </section>
  );
}
